var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHomePlatformAdv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 71,
    viewBox: "0 0 99 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9922 71.0027L78.0199 57.6594L38.149 17.6068L18.828 34.0726L0 14.9126L8.48051 6.59947L18.828 17.6057L38.149 0L85.9043 48.3977L99.0012 36.6715V71L65.9922 71.0027Z",
    fill: "#D51E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.0012,
    height: 71.0027,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomePlatformAdv);
export default __webpack_public_path__ + "static/media/icon_home_platform_adv.b0f44e06dfa57b39df18f13bfd805293.svg";
export { ForwardRef as ReactComponent };